var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { ContentPortal } from "../layout/contentportal";
import { bind } from "decko";
import { CSSTransition } from "react-transition-group";
import { css } from "emotion";
import { getThemeColorVar } from "../helper/color";
const animationMillis = 200;
const sidePanelWrapperClass = css({
    zIndex: 10000,
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: "hidden",
    h2: {
        fontSize: "20px",
        fontWeight: "bold",
        lineHeight: "26px",
        width: "100%",
    },
});
const sidePanelContentClass = css({
    height: "100%",
    position: "absolute",
    right: 0,
    top: 0,
    width: "400px",
    backgroundColor: getThemeColorVar("background", "default"),
    boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.3)",
});
const sidePanelOverlayClass = css({
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "#000",
    opacity: 0.3,
});
const sidePanelTransitions = {
    enter: css({
        [`.${sidePanelContentClass}`]: { right: "-400px" },
        [`.${sidePanelOverlayClass}`]: { opacity: 0 },
    }),
    enterActive: css({
        [`.${sidePanelContentClass}`]: {
            right: 0,
            transition: `right ${animationMillis}ms`,
        },
        [`.${sidePanelOverlayClass}`]: {
            opacity: 0.3,
            transition: `opacity ${animationMillis}ms`,
        },
    }),
    enterDone: css({
        [`.${sidePanelContentClass}`]: { right: 0 },
        [`.${sidePanelOverlayClass}`]: { opacity: 0.3 },
    }),
    exit: css({
        [`.${sidePanelContentClass}`]: { right: 0 },
        [`.${sidePanelOverlayClass}`]: { opacity: 0.3 },
    }),
    exitActive: css({
        [`.${sidePanelContentClass}`]: {
            right: "-400px",
            transition: `right ${animationMillis}ms`,
        },
        [`.${sidePanelOverlayClass}`]: {
            opacity: 0,
            transition: `opacity ${animationMillis}ms`,
        },
    }),
    exitDone: css({
        [`.${sidePanelContentClass}`]: { right: "-400px" },
        [`.${sidePanelOverlayClass}`]: { opacity: 0 },
    }),
};
export class BareSidePanel extends React.Component {
    render() {
        const { children, opened, sticky } = this.props;
        return (React.createElement(ContentPortal, null,
            React.createElement(CSSTransition, { classNames: sidePanelTransitions, timeout: animationMillis, in: opened, mountOnEnter: true, unmountOnExit: true },
                React.createElement("div", { className: sidePanelWrapperClass },
                    React.createElement("div", { className: sidePanelOverlayClass, onClick: sticky ? () => { } : this.handleCloseButton }),
                    React.createElement("div", { className: sidePanelContentClass }, children)))));
    }
    handleCloseButton(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onClose && this.props.onClose();
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BareSidePanel.prototype, "handleCloseButton", null);
export default BareSidePanel;
//# sourceMappingURL=baresidepanel.js.map